import { render, staticRenderFns } from "./PlainTextComponent.vue?vue&type=template&id=257f5068&"
import script from "./PlainTextComponent.vue?vue&type=script&lang=js&"
export * from "./PlainTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports